import { render, staticRenderFns } from "./CreateTestPaperModal.vue?vue&type=template&id=f7cc98d2&scoped=true"
import script from "./CreateTestPaperModal.vue?vue&type=script&lang=js"
export * from "./CreateTestPaperModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTestPaperModal.vue?vue&type=style&index=0&id=f7cc98d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cc98d2",
  null
  
)

export default component.exports